import React from "react";
// If you are looking for functions or logic to change here, please see app-menu.jsx

import PropTypes from "prop-types";
import Dispatcher from "../../dispatcher";
import FractionStore from "../../stores/fraction-store";
import AppMenu from "../layouts/app-menu";
import MainMenuMixin from "./main-menu-mixin";

var Menu = require("../ui_elements/menu").Menu;
var MenuList = require("../ui_elements/menu-list");
var Isvg = require("../../../vendor/react-inlinesvg");

class MainMenu extends AppMenu.Component {
  constructor(props) {
    super(props);
    this.state = {
      env: "main-menu",
      mainMenuHidden: this._getMainMenuBarState()
    };
    this._escapeKey = this._escapeKey.bind(this);
    this._userChange = this._userChange.bind(this);
    this._windowResize = this._windowResize.bind(this);
    this._mainMenuHidden = this._mainMenuHidden.bind(this);
  }

  componentDidMount() {
    $(window).on("keyup", this._escapeKey);

    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 3);
    Dispatcher.bind(Dispatcher.USER_CHANGE, this._userChange);
    Dispatcher.bind(Dispatcher.FRACTION_STORE_CHANGE, this._mainMenuHidden);

    Fraction.Helpers.getUser(function() {}, { skipAuth: true });
    window.addEventListener("resize", this._windowResize);
  }

  componentWillUnmount() {
    clearTimeout(this.mainMenuHiddenTimeout);
    window.removeEventListener("resize", this._windowResize);
    $(window).unbind("keyup", this._escapeKey);

    Dispatcher.unbind(Dispatcher.USER_CHANGE, this._userChange);
    Dispatcher.unbind(Dispatcher.FRACTION_STORE_CHANGE, this._mainMenuHidden);
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() - 3);
  }

  _escapeKey(e) {
    if (e.keyCode === 27) {
      MainMenuMixin._menuClose(e);
      MainMenuMixin._menuRefocus(e);
    }
  }

  _userChange() {
    this.forceUpdate();
  }

  _windowResize(e) {
    MainMenuMixin._menuClose(e);
  }

  _getMainMenuBarState() {
    return FractionStore.get()["main-menu-open"] ? "block" : "none";
  }

  _mainMenuHidden() {
    clearTimeout(this.mainMenuHiddenTimeout);
    this.mainMenuHiddenTimeout = setTimeout(() => {
      this.setState({ mainMenuHidden: this._getMainMenuBarState() });
    }, 333);
  }

  render() {
    var mainMenuList = "";
    var powerByPosition = "";
    const mainMenuHidden = this.state.mainMenuHidden;

    if (this.props.powerByPositionSt === 2) {
      powerByPosition = "menu-logo-signout";
    } else {
      powerByPosition = "menu-logo";
    }

    var mainMenuHeader = (
      <h2 id="mainMenuHeader" tabIndex={-1}>
        {i18n.t("reader.buttons.main-menu")}
      </h2>
    );

    var referenceUser =
      Fraction.User &&
      (Fraction.User.ssoOnly && !Fraction.Brand.AccountCompletion.ssoEnabled);

    var isErrorPage = this.props.environment === "error-page";

    if (!Fraction.User || isErrorPage) {
      mainMenuList = (
        <div>
          <div
            style={{ display: mainMenuHidden }}
            className="main-menu menu-hidden"
          >
            {mainMenuHeader}
            <div className="user-header">
              <div className="user-full-name">Welcome to Bookshelf</div>
            </div>
            <div className="main-menu-inner">
              <ul>
                {Fraction.Brand.Library.visible &&
                  Fraction.Brand.Bookshelf.visible && (
                    <li
                      key="main-menu-bookshelf-item"
                      className={`bookshelf-item ${Fraction.Brand.Bookshelf
                        .icon || ""}`}
                    >
                      <a href="#" onClick={this._clickBookshelf}>
                        {Fraction.Brand.Bookshelf.icon === "default" && (
                          <Isvg
                            className="icon"
                            src="/img/circle_bookshelf_sm.svg"
                          />
                        )}
                        {Fraction.Brand.Bookshelf.icon === "reader" && (
                          <Isvg
                            className="icon"
                            src="/img/circle_reader_sm.svg"
                          />
                        )}
                        <span className="label">
                          {Fraction.Brand.Bookshelf.label ||
                            i18n.t("global-bar.bookshelf")}
                        </span>
                      </a>
                    </li>
                  )}
                {Fraction.Brand.Store.visible && (
                  <li
                    key="main-menu-store-item"
                    className={`store-item ${Fraction.Brand.Store.icon || ""}`}
                  >
                    <a href="#" target="_blank" onClick={this._clickStore}>
                      {Fraction.Brand.Store.icon === "default" && (
                        <Isvg className="icon" src="/img/circle_store_sm.svg" />
                      )}
                      {Fraction.Brand.Store.icon === "arrow" && (
                        <Isvg className="icon" src="/img/circle_arrow_sm.svg" />
                      )}
                      {Fraction.Brand.Store.icon === "mobile" && (
                        <Isvg className="icon" src="/img/circle_mobile.svg" />
                      )}
                      <span className="label">
                        {Fraction.Brand.Store.label || i18n.t("global-bar.store")}
                      </span>
                    </a>
                  </li>
                )}
                {Fraction.Brand.Support.visible && (
                  <li
                    key="main-menu-support-item"
                    className={`support-item ${Fraction.Brand.Support.icon ||
                      ""}`}
                  >
                    <a href="#" target="_blank" onClick={this._clickSupport}>
                      {Fraction.Brand.Support.icon === "default" && (
                        <Isvg
                          className="icon"
                          src="/img/circle_support_sm.svg"
                        />
                      )}
                      {Fraction.Brand.Support.icon === "arrow" && (
                        <Isvg className="icon" src="/img/circle_arrow_sm.svg" />
                      )}
                      <span className="label">
                        {Fraction.Brand.Support.label || i18n.t("global-bar.support")}
                      </span>
                    </a>
                  </li>
                )}

                <li
                  key="main-menu-divider-xy72"
                  className="divider"
                  aria-hidden="true"
                />
                <li
                  key="main-menu-about-item"
                  className={`about-item ${Fraction.Brand.About.icon || ""}`}
                >
                  <a href="#" target="_blank" onClick={this._clickAbout}>
                    {Fraction.Brand.About.icon === "default" && (
                      <Isvg className="icon" src="/img/about.svg" />
                    )}
                    {Fraction.Brand.About.icon === "custom" && (
                      <Isvg
                        className="icon custom"
                        src={Fraction.Brand.About.icon}
                      />
                    )}
                    <span className="label">
                      {Fraction.Brand.About.label || i18n.t("global-bar.about")}
                    </span>
                  </a>
                </li>
              </ul>
              {Fraction.Brand.Menu.poweredBy && (
                <div className={`${powerByPosition} powered-by`}>
                  {window.toHTML(
                    i18n.t("base.poweredBy", {
                      url: "/img/vitalsource_white.svg"
                    })
                  )}
                </div>
              )}
            </div>
          </div>
          <button
            aria-label={i18n.t("main-menu.close-main-menu")}
            tabIndex={0}
            className="noButton menu-close-container menu-close-hidden"
            onClick={MainMenuMixin._menuClose}
          />
        </div>
      );
    } else {
      let menuItemList = [];
      let needsDivider = false;
      if (Fraction.Helpers.ReadOffline.shouldReadOffline()) {
        menuItemList.push(
          <li key="main-menu-read-offline" className="read-offline-item">
            <a className="read-offline" href="#" onClick={this._launchInApp}>
              {i18n.t("main-menu.launch-app")}
            </a>
            <a
              className="read-offline download"
              href="#"
              onClick={this._downloadApp}
            >
              {i18n.t("main-menu.download-app")}
            </a>
          </li>
        );
        menuItemList.push(
          <li
            key="main-menu-divider-xy73"
            className="divider"
            aria-hidden="true"
          />
        );
      }
      if (this.shouldShowLibrary()) {
        menuItemList.push(
          <li key="main-menu-library-item" className="library-item">
            <a href="#" onClick={this._libraryButton}>
              <Isvg className="icon" src="/img/library.svg" />
              <span className="label">{i18n.t("main-menu.library")}</span>
            </a>
          </li>
        );
        menuItemList.push(
          <li
            key="main-menu-divider-xy74"
            className="divider"
            aria-hidden="true"
          />
        );
      }
      if (this.shouldShowSharing()) {
        needsDivider = true;
        menuItemList.push(
          <li key="main-menu-sharing-item" className="sharing-item">
            <button onClick={this._clickSharing}>
              <Isvg className="icon" src="/img/sharing.svg" />
              <span className="label">{i18n.t("main-menu.sharing")}</span>
            </button>
          </li>
        );
      }
      if (this.shouldShowHighlighters()) {
        needsDivider = true;
        menuItemList.push(
          <li key="main-menu-highlighters-item" className="highlighters-item">
            <button onClick={this._clickHighlighters}>
              <Isvg className="icon" src="/img/highlighters.svg" />
              <span className="label">{i18n.t("main-menu.highlighters")}</span>
            </button>
          </li>
        );
      }
      if (needsDivider) {
        menuItemList.push(
          <li
            key="main-menu-divider-1"
            className="divider"
            aria-hidden="true"
          />
        );
        needsDivider = false;
      }
      if (this.shouldShowUpdateLicense()) {
        needsDivider = true;
        menuItemList.push(
          <li key="main-menu-update-item" className="update-item">
            <button onClick={this._updateLicense}>
              <Isvg className="icon" src="/img/update.svg" />
              <span className="label">{i18n.t("main-menu.update")}</span>
            </button>
          </li>
        );
      }
      if (this.shouldShowRedeem()) {
        needsDivider = true;
        menuItemList.push(
          <li key="main-menu-redeem-item" className="redeem-item">
            <button onClick={this._redeem}>
              <Isvg className="icon" src="/img/redeem.svg" />
              <span className="label">{i18n.t("global-bar.redeem")}</span>
            </button>
          </li>
        );
      }
      if (needsDivider) {
        menuItemList.push(
          <li
            key="main-menu-divider-2"
            className="divider"
            aria-hidden="true"
          />
        );
        needsDivider = false;
      }
      if (this.shouldShowUserInfo()) {
        needsDivider = true;
        menuItemList.push(
          <li key="main-menu-user-info-item" className="user-info-item">
            <button onClick={this._clickUserInfo}>
              <Isvg className="icon" src="/img/user_info2.svg" />
              <span className="label">{i18n.t("main-menu.user-info")}</span>
            </button>
          </li>
        );
      }
      if (this.shouldShowDevices()) {
        needsDivider = true;
        menuItemList.push(
          <li key="main-menu-devices-item" className="devices-item">
            <button onClick={this._clickDevices}>
              <Isvg className="icon" src="/img/devices.svg" />
              <span className="label">{i18n.t("main-menu.devices")}</span>
            </button>
          </li>
        );
      }
      if (this.shouldShowPOD()) {
        needsDivider = true;
        menuItemList.push(
          <li key="main-menu-pod-item" className="pod-item">
            <button onClick={this._clickPOD}>
              <Isvg className="icon" src="/img/print_on_demand.svg" />
              <span className="label">
                {i18n.t("main-menu.print-on-demand")}
              </span>
            </button>
          </li>
        );
      }
      if (this.shouldShowResources()) {
        needsDivider = true;
        menuItemList.push(
          <li key="main-menu-resources-item" className="resources-item">
            <button onClick={this._clickResources}>
              <Isvg className="icon" src="/img/resources_main_menu.svg" />
              <span className="label">{i18n.t("main-menu.resources")}</span>
            </button>
          </li>
        );
      }
      if (this.shouldShowOptOut()) {
        needsDivider = true;
        menuItemList.push(
          <li key="main-menu-opt-out-item" className="opt-out-item">
            <button onClick={this._clickOptOut}>
              <Isvg className="icon" src="/img/opt_out.svg" />
              <span className="label">{i18n.t("main-menu.opt-out")}</span>
            </button>
          </li>
        );
      }
      if (needsDivider) {
        menuItemList.push(
          <li
            key="main-menu-divider-4"
            className="divider"
            aria-hidden="true"
          />
        );
        needsDivider = false;
      }
      if (this.shouldShowLibrary()) {
        needsDivider = true;
        menuItemList.push(
          <li
            key="main-menu-bookshelf-item"
            className={`bookshelf-item ${Fraction.Brand.Bookshelf.icon || ""}`}
          >
            <a href="#" onClick={this._clickBookshelf}>
              {Fraction.Brand.Bookshelf.icon === "default" && (
                <Isvg className="icon" src="/img/circle_bookshelf_sm.svg" />
              )}
              {Fraction.Brand.Bookshelf.icon === "reader" && (
                <Isvg className="icon" src="/img/circle_reader_sm.svg" />
              )}
              {Fraction.Brand.Bookshelf.icon === "custom" && (
                <Isvg
                  className="icon custom"
                  src={Fraction.Brand.Bookshelf.customIcon}
                />
              )}
              <span className="label">
                {Fraction.Brand.Bookshelf.label ||
                  i18n.t("global-bar.bookshelf")}
              </span>
            </a>
          </li>
        );
      }
      if (this.shouldShowStore()) {
        needsDivider = true;
        menuItemList.push(
          <li
            key="main-menu-store-item"
            className={`store-item ${Fraction.Brand.Store.icon || ""}`}
          >
            <a href="#" target="_blank" onClick={this._clickStore}>
              {Fraction.Brand.Store.icon === "default" && (
                <Isvg className="icon" src="/img/circle_store_sm.svg" />
              )}
              {Fraction.Brand.Store.icon === "arrow" && (
                <Isvg className="icon" src="/img/circle_arrow_sm.svg" />
              )}
              {Fraction.Brand.Store.icon === "mobile" && (
                <Isvg className="icon" src="/img/circle_mobile.svg" />
              )}
              {Fraction.Brand.Store.icon === "custom" && (
                <Isvg
                  className="icon custom"
                  src={Fraction.Brand.Store.customIcon}
                />
              )}
              <span className="label">
                {Fraction.Brand.Store.label || i18n.t("global-bar.store")}
              </span>
            </a>
          </li>
        );
      }
      if (this.shouldShowSupport()) {
        needsDivider = true;
        menuItemList.push(
          <li
            key="main-menu-support-item"
            className={`support-item ${Fraction.Brand.Support.icon || ""}`}
          >
            <a href="#" target="_blank" onClick={this._clickSupport}>
              {Fraction.Brand.Support.icon === "default" && (
                <Isvg className="icon" src="/img/circle_support_sm.svg" />
              )}
              {Fraction.Brand.Support.icon === "arrow" && (
                <Isvg className="icon" src="/img/circle_arrow_sm.svg" />
              )}
              {Fraction.Brand.Support.icon === "custom" && (
                <Isvg
                  className="icon custom"
                  src={Fraction.Brand.Support.customIcon}
                />
              )}
              <span className="label">
                {Fraction.Brand.Support.label || i18n.t("global-bar.support")}
              </span>
            </a>
          </li>
        );
      }

      if (this.shouldShowVstAnalytics()) {
        needsDivider = true;
        menuItemList.push(
          <li
            key="main-menu-vst-analytics-item"
            className={`vst-analytics-item ${
              Fraction.Brand.VstAnalytics.icon
                ? Fraction.Brand.VstAnalytics.icon
                : ""
            }`}
          >
            <a href="#" target="_blank" onClick={this._clickVstAnalytics}>
              {Fraction.Brand.VstAnalytics.icon === "default" && (
                <Isvg className="icon" src="/img/circle_arrow_sm.svg" />
              )}
              {Fraction.Brand.VstAnalytics.icon === "arrow" && (
                <Isvg className="icon" src="/img/circle_arrow_sm.svg" />
              )}
              {Fraction.Brand.VstAnalytics.icon === "custom" && (
                <Isvg
                  className="icon custom"
                  src={Fraction.Brand.VstAnalytics.customIcon}
                />
              )}
              <span className="label">
                {Fraction.Brand.VstAnalytics.label ||
                  i18n.t("global-bar.vst-analytics")}
              </span>
            </a>
          </li>
        );
      }

      // We've removed the score center app button for now
      if (false && this.shouldShowScoreCenter()) {
        menuItemList.push(
          <li
            key="main-menu-score-center-item"
            className={`score-center-item ${Fraction.Brand.ScoreCenter.icon ||
              ""}`}
          >
            <a href="#" onClick={this._clickScoreCenter}>
              {Fraction.Brand.ScoreCenter.icon === "default" && (
                <Isvg className="icon" src="/img/circle_support_sm.svg" />
              )}
              {Fraction.Brand.ScoreCenter.icon === "arrow" && (
                <Isvg className="icon" src="/img/circle_arrow_sm.svg" />
              )}
              <span className="label">
                {Fraction.Brand.ScoreCenter.label ||
                  i18n.t("global-bar.score_center")}
              </span>
            </a>
          </li>
        );
      }

      Fraction.Brand.AppMenu.elements.forEach(element => {
        if (element.enabled) {
          needsDivider = true;
          menuItemList.push(
            <li
              key={`main-menu-app-item-${element.key || element.label}`}
              className="app-menu-item"
            >
              <a
                href="#"
                target="_blank"
                onClick={e => {
                  this._clickAppMenuElement(e, element);
                }}
              >
                <Isvg className="icon" src="/img/circle_arrow_sm.svg" />
                <span className="label">{element.label}</span>
              </a>
            </li>
          );
        }
      });

      if (needsDivider) {
        menuItemList.push(
          <li
            key="main-menu-divider-5"
            className="divider"
            aria-hidden="true"
          />
        );
        needsDivider = false;
      }
      if (this.shouldShowAbout()) {
        needsDivider = true;
        menuItemList.push(
          <li
            key="main-menu-about-item"
            className={`about-item ${Fraction.Brand.About.icon || ""}`}
          >
            <a href="#" target="_blank" onClick={this._clickAbout}>
              {Fraction.Brand.About.icon === "default" && (
                <Isvg className="icon" src="/img/about.svg" />
              )}
              {Fraction.Brand.About.icon === "custom" && (
                <Isvg
                  className="icon custom"
                  src={Fraction.Brand.About.customIcon}
                />
              )}
              <span className="label">
                {Fraction.Brand.About.label || i18n.t("global-bar.about")}
              </span>
            </a>
          </li>
        );
      }
      if (this.shouldShowLogout()) {
        needsDivider = true;
        menuItemList.push(
          <li key="main-menu-sign-out-item" className="sign-out-item">
            <button onClick={this._logOut}>
              <Isvg className="icon" src="/img/sign_out.svg" />
              <span className="label">{i18n.t("global-bar.sign-out")}</span>
            </button>
          </li>
        );
      }
      if (needsDivider) {
        menuItemList.push(
          <li
            key="main-menu-divider-6"
            className="divider"
            aria-hidden="true"
          />
        );
        needsDivider = false;
      }
      mainMenuList = (
        <div>
          <div
            style={{ display: mainMenuHidden }}
            className="main-menu menu-hidden"
          >
            {mainMenuHeader}
            {!Fraction.Brand.AccountCompletion.ssoOnly && (
              <div className="user-header">
                {!Fraction.User.ssoOnly && (
                  <span>
                    <div className="user-full-name">
                      {Fraction.User && Fraction.User.firstName}{" "}
                      {Fraction.User && Fraction.User.lastName}
                    </div>
                    <div className="user-email-address">
                      {Fraction.User && Fraction.User.email}
                    </div>
                  </span>
                )}
              </div>
            )}
            <div className="main-menu-inner">
              <ul>{menuItemList}</ul>
              {Fraction.Brand.Menu.poweredBy && (
                <div className={`${powerByPosition} powered-by`}>
                  {window.toHTML(
                    i18n.t("base.poweredBy", {
                      url: "/img/vitalsource_white.svg"
                    })
                  )}
                </div>
              )}
            </div>
          </div>
          <button
            tabIndex={0}
            className="noButton menu-close-container menu-close-hidden"
            onClick={MainMenuMixin._menuClose}
          >
            <span className="offScreen">
              {i18n.t("main-menu.close-main-menu")}
            </span>
          </button>
        </div>
      );
    }
    return (
      <div
        id="main-menu-container"
        aria-hidden={!FractionStore.get()["main-menu-open"]}
      >
        {mainMenuList}
      </div>
    );
  }
}

MainMenu.propTypes = {
  powerByPositionSt: PropTypes.number,
  environment: PropTypes.string
};
MainMenu.defaultProps = {
  powerByPosition: 1,
  environment: ""
};

export { MainMenu };
